export default {
  name: 'marking--mrkTreeType',
};